function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import firestore, { getReferenceData } from '@paperstac/firebase/lib/firestore';
import get from 'lodash/get';
var delay = require('delay');
var log = function log(message) {
  var _console;
  for (var _len = arguments.length, extra = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    extra[_key - 1] = arguments[_key];
  }
  (_console = console).log.apply(_console, ["[FirestoreTransactionManager] ".concat(message)].concat(extra));
};
var MAX_OPERATIONS = 500;
var FirestoreTransactionManager = /*#__PURE__*/function () {
  function FirestoreTransactionManager(fsTransaction) {
    _classCallCheck(this, FirestoreTransactionManager);
    if (_typeof(fsTransaction) !== 'object' || !fsTransaction.get || !fsTransaction.set) throw new Error('A Firestore Transaction is required.');
    this.fsTransaction = fsTransaction;
    this.cache = {};
    this.operationCount = 0;
    this.pendingWrites = {};
    this.queue = [];
    this.now = new Date();
  }
  _createClass(FirestoreTransactionManager, [{
    key: "getTransaction",
    value: function getTransaction() {
      return this.fsTransaction;
    }
  }, {
    key: "_incrementOperation",
    value: function _incrementOperation() {
      this.operationCount++;
      if (this.operationCount > MAX_OPERATIONS) {
        var message = "Maximum operation count (".concat(MAX_OPERATIONS, ") has been exceeded (").concat(Object.keys(this.cache).length, " reads, ").concat(this.queue.length, " writes).");
        log(message);
        this.queue.forEach(function (_ref, i) {
          var method = _ref.method,
            _ref$args = _slicedToArray(_ref.args, 2),
            documentRef = _ref$args[0],
            data = _ref$args[1];
          return console.log("".concat(i + 1).padStart(3, '0') + ')', method, documentRef.path, data);
        });
        throw new Error(message);
      }
    }
  }, {
    key: "get",
    value: function get(documentRef) {
      if (!this.cache[documentRef.path]) {
        this._incrementOperation();
        this.cache[documentRef.path] = this.fsTransaction.get(documentRef);
        log('Fetching:', documentRef.path);
      }
      return this.cache[documentRef.path];
    }
  }, {
    key: "set",
    value: function set(documentRef, data, options) {
      this._incrementOperation();
      this.pendingWrites[documentRef.path] = true;
      delete this.cache["".concat(documentRef.path, ".pending")];
      log('Queuing:', 'set', documentRef.path, data);
      this.queue.push({
        method: 'set',
        args: [documentRef, data, options]
      });
      return FirestoreTransactionManager.writeCallback(this, 'set', documentRef, data, options);
    }
  }, {
    key: "update",
    value: function update(documentRef, data) {
      this._incrementOperation();
      this.pendingWrites[documentRef.path] = true;
      delete this.cache["".concat(documentRef.path, ".pending")];
      log('Queuing:', 'update', documentRef.path, data);
      this.queue.push({
        method: 'update',
        args: [documentRef, data]
      });
      return FirestoreTransactionManager.writeCallback(this, 'update', documentRef, data);
    }
  }, {
    key: "delete",
    value: function _delete(documentRef) {
      this._incrementOperation();
      delete this.cache["".concat(documentRef.path, ".pending")];
      log('Queuing:', 'delete', documentRef.path);
      this.queue.push({
        method: 'delete',
        args: [documentRef]
      });
      return FirestoreTransactionManager.writeCallback(this, 'delete', documentRef);
    }
  }, {
    key: "getCurrentData",
    value: function getCurrentData(documentRef) {
      var cacheKey = "".concat(documentRef.path, ".current");
      if (!this.cache[cacheKey]) this.cache[cacheKey] = this.get(documentRef).then(function (snap) {
        return snap.docs ? snap.docs.filter(function (docSnap) {
          return docSnap.exists;
        }).map(function (docSnap) {
          return docSnap.data();
        }) : snap.data();
      });
      return this.cache[cacheKey];
    }
  }, {
    key: "getPreviousData",
    value: function getPreviousData(documentRef) {
      var cacheKey = "".concat(documentRef.path, ".previous");
      return this.cache[cacheKey] ? Promise.resolve(this.cache[cacheKey]) : this.getCurrentData(documentRef);
    }
  }, {
    key: "setPreviousData",
    value: function setPreviousData(documentSnapshot) {
      var cacheKey = "".concat(documentSnapshot.ref.path, ".previous");
      this.cache[cacheKey] = Promise.resolve(documentSnapshot.data());
    }
  }, {
    key: "getPendingData",
    value: function getPendingData(documentRef) {
      var _this = this;
      if (!documentRef.path) throw new Error('Invalid DocumentReference given.');
      if (!isEven(documentRef.path.split('/').length)) {
        return this._getPendingCollectionData(documentRef);
      }
      var cacheKey = "".concat(documentRef.path, ".pending");
      if (this.cache[cacheKey]) return this.cache[cacheKey];
      var sanitize = function sanitize(doc) {
        return Object.keys(doc).reduce(function (sanitized, prop) {
          var propValue = doc[prop];
          var constructorName = _typeof(propValue) === 'object' && get(propValue, '__proto__.constructor.name');
          if (!!propValue && _typeof(propValue) === 'object' && ['DeleteTransform', 'DeleteFieldValueImpl'].includes(constructorName)) {
            return sanitized;
          } else if (!!propValue && _typeof(propValue) === 'object' && constructorName === 'Object') {
            sanitized[prop] = sanitize(propValue);
          } else {
            sanitized[prop] = propValue;
          }
          return sanitized;
        }, {});
      };
      this.cache[cacheKey] = this.getCurrentData(documentRef).then(function (initialData) {
        return _this.queue.filter(function (queueItem) {
          return _this._getQueueItemDocumentRef(queueItem).path === documentRef.path;
        }).reduce(function (latestData, _ref2) {
          var method = _ref2.method,
            args = _ref2.args;
          var _args = _slicedToArray(args, 3),
            documentRef = _args[0],
            data = _args[1],
            options = _args[2];
          if (method === 'set' && !get(options, 'merge')) return sanitize(data);
          if (method === 'delete') return null;
          return sanitize(_objectSpread(_objectSpread({}, latestData), data));
        }, initialData);
      });
      return this.cache[cacheKey];
    }
  }, {
    key: "_getPendingCollectionData",
    value: function () {
      var _getPendingCollectionData2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(collectionRef) {
        var _this2 = this;
        var cacheKey, currentCollection, resource, pendingCollection, collection;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cacheKey = "".concat(collectionRef.path, ".current");
                if (!this.cache[cacheKey]) this.cache[cacheKey] = getReferenceData(collectionRef);
                _context.next = 4;
                return this.cache[cacheKey];
              case 4:
                currentCollection = _context.sent;
                resource = getResourceFromDocumentRef(collectionRef);
                _context.next = 8;
                return Promise.all(this.queue.filter(function (queueItem) {
                  return getResourceFromDocumentRef(_this2._getQueueItemDocumentRef(queueItem)) === resource;
                }).map(function (queueItem) {
                  return _this2.getPendingData(_this2._getQueueItemDocumentRef(queueItem));
                }));
              case 8:
                pendingCollection = _context.sent;
                // Replace current items with matching pending items (if they exist) in collection
                collection = currentCollection.map(function (currentItem) {
                  var pendingItem = pendingCollection.find(function (pendingItem) {
                    return pendingItem.id === currentItem.id;
                  });
                  return pendingItem || currentItem;
                }); // Append new items to end of collection
                pendingCollection.forEach(function (pendingItem) {
                  var currentItem = currentCollection.find(function (currentItem) {
                    return currentItem.id === pendingItem.id;
                  });
                  if (!currentItem) collection.push(pendingItem);
                });
                return _context.abrupt("return", collection);
              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function _getPendingCollectionData(_x2) {
        return _getPendingCollectionData2.apply(this, arguments);
      }
      return _getPendingCollectionData;
    }()
  }, {
    key: "_getQueueItemDocumentRef",
    value: function _getQueueItemDocumentRef(queueItem) {
      return queueItem.args[0];
    }
  }, {
    key: "hasPendingWrites",
    value: function hasPendingWrites(documentRef) {
      return !!this.pendingWrites[documentRef.path];
    }
  }, {
    key: "pendingWriteCount",
    value: function pendingWriteCount() {
      return this.queue.length;
    }
  }, {
    key: "commit",
    value: function commit() {
      log("Starting commit after ".concat(this.operationCount, " operations occurred..."));
      this.cache = {};
      this.pendingWrites = {};
      this.operationCount = 0;
      while (this.queue.length) {
        var _this$queue$shift = this.queue.shift(),
          method = _this$queue$shift.method,
          args = _this$queue$shift.args;
        var documentRef = args.shift();
        if (documentRef) {
          var _this$fsTransaction;
          log.apply(void 0, ['Committing:', method, documentRef.path].concat(_toConsumableArray(args)));
          (_this$fsTransaction = this.fsTransaction)[method].apply(_this$fsTransaction, [documentRef].concat(_toConsumableArray(args)));
        } else {
          var _console2;
          (_console2 = console).error.apply(_console2, ['Not committing due to invalid documentRef:', method, documentRef].concat(_toConsumableArray(args)));
        }
      }
      log('Commit is complete.');
    }
  }]);
  return FirestoreTransactionManager;
}();
export { FirestoreTransactionManager as default };
FirestoreTransactionManager.writeCallback = function () {
  log('FirestoreTransactionManager.writeCallback() was not defined.');
};
FirestoreTransactionManager.withManager = function (callback) {
  var collisionAvoider = createCollisionAvoider();
  return firestore.runTransaction( /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(fsTransaction) {
      var manager, response;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              manager = new FirestoreTransactionManager(fsTransaction);
              _context2.next = 3;
              return collisionAvoider.avoidCollision();
            case 3:
              _context2.next = 5;
              return callback(manager);
            case 5:
              response = _context2.sent;
              manager.commit();
              return _context2.abrupt("return", response);
            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }());
};
var createCollisionAvoider = function createCollisionAvoider() {
  var minimumDelayMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var attempts = 0;
  return {
    avoidCollision: function avoidCollision() {
      var randomDelay = attempts === 0 ? 0 : Math.round(Math.pow(3, attempts) * 1000 * Math.random());
      attempts++;
      var delayMs = Math.max(minimumDelayMs, randomDelay);
      if (attempts > 1) {
        console.log("[FirestoreTransactionManager] Collision occurred. Delaying attempt #".concat(attempts, " by ").concat(delayMs, "ms"));
      }
      return delay(delayMs);
    }
  };
};
export var getResourceFromDocumentRef = function getResourceFromDocumentRef(documentRef) {
  return documentRef.path.split('/').reduce(function (resource, part, index) {
    if (index === 0) return part;
    if (!isEven(index)) return resource;
    return "".concat(resource).concat(capitalize(part));
  }, '');
};
var capitalize = function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
var isEven = function isEven(val) {
  return val % 2 === 0;
};